import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Asegúrate de importar Bootstrap
import { Modales } from '../Modales';
import { Formsede } from './Formsede';
import { actualizarDatos } from '../../api/common';
import { Alertassw } from '../Alertas/Alertassw';
import { Modalcarga } from '../Modales/Modalcarga';
import Spinner from '../commons/Spinner';

const ClientInfo = ({ cliente, Sedeinfo, onEdit, sedes,  setSedes, setSedeSelect}) => {

    const [sedeEdit, setSedeEdit]=useState(Sedeinfo)
    const [visible, setVisible] = useState(false);
    const [missingInfo, setMissingInfo] = useState(false);
    const [modal, setModal] = useState({});
    const [estadomodalIn, setEstadomodalIn]=useState(false)


    console.log({...sedeEdit})

  useEffect(() => {
    if (Sedeinfo && Object.keys(Sedeinfo).length > 0) {
      setVisible(true);
      setSedeEdit(Sedeinfo)
      // Verifica si hay algún campo vacío o undefined en Sedeinfo
      const requiredFields = ["ciudad", "dirSede", "contSede", "celContacto", "emailContacto"];
      const isMissing = requiredFields.some((field) => !Sedeinfo[field]);

      setModal(isMissing)
      setMissingInfo(isMissing);
    } else {
      setVisible(false);
      setMissingInfo(true);
    }
  }, [Sedeinfo]);

  const editarSede=(event)=>{
    if(event.target.name==='departamento'){
    setSedeEdit({
        ...sedeEdit,
        [event.target.name]:event.target.value,
        ciudad:''
    })}
    else{
        setSedeEdit({
            ...sedeEdit,
            [event.target.name]:event.target.value
        })
    }
  }

  const enviardata = async()=>{
    setEstadomodalIn(true)

    try {
        const sedeActualizada = await actualizarDatos('Sedes',{...sedeEdit},sedeEdit._id)
        // Reemplaza la sede en el array

        const sedesActualizadas = sedes?.map((sede) =>
            sede._id === sedeActualizada.data.data._id ? sedeActualizada.data.data : sede
        );
        console.log('sedes actualizadas',sedesActualizadas)
        setSedes(sedesActualizadas)
        setSedeSelect(sedeActualizada.data.data)
        setEstadomodalIn(false)
        setModal(false)
    } catch (error) {
        console.log(error)
        Alertassw('error','Error de edición','Intent nuevamente, si el error persites contacta a soporte técnico')
        setModal(false)
    }

  }

  return (
    <div
      className={`position-relative border rounded p-2 shadow-sm bg-light transition ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
      }`}
      style={{
        transition: 'opacity 1s ease, transform 1s ease',
        display: visible ? 'block' : 'none',
      }}
    >
        <Modalcarga
            estadoIn={estadomodalIn} 
            cambiarestadoIn={setEstadomodalIn}
        >
            <Spinner/>
        </Modalcarga>
        <Modales
             estado={modal} 
             cambiarestado={setModal}
             titulo={'Editar Sede'}
        >
            <Formsede dataSede={editarSede} Enviar={enviardata} dataDefault={Sedeinfo}/>
        </Modales>
         {missingInfo && (
        <div className="alert alert-warning text-center" role="alert">
          ⚠️ Falta información en la sede, por favor complétala.
        </div>
      )}
      <div className="row mx-1">
        <div className="col-md-6">
          <div className="d-flex align-items-center">
            <label className="form-label fw-bold me-2 mb-0">Nit:</label>
            <p className="mb-0">{cliente?.identificacion}</p>
          </div>
          <div className="d-flex align-items-center">
            <label className="form-label fw-bold me-2 mb-0">Ciudad:</label>
            <p className="mb-0">{Sedeinfo?.ciudad +" / "+Sedeinfo?.departamento}</p>
          </div>
          <div className="d-flex align-items-center">
            <label className="form-label fw-bold me-2 mb-0">Dirección:</label>
            <p className="mb-0">{Sedeinfo?.dirSede}</p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="d-flex align-items-center">
            <label className="form-label fw-bold me-2 mb-0">Contacto:</label>
            <p className="mb-0">{Sedeinfo?.contSede}</p>
          </div>
          <div className="d-flex align-items-center">
            <label className="form-label fw-bold me-2 mb-0">Teléfono:</label>
            <p className="mb-0">{Sedeinfo?.celContacto}</p>
          </div>
          <div className="d-flex align-items-center">
            <label className="form-label fw-bold me-2 mb-0">Correo:</label>
            <p className="mb-0 text-break">{Sedeinfo?.emailContacto}</p>
          </div>
        </div>
      </div>

      <button
        onClick={()=>setModal(true)}
        className="btn btn-primary position-absolute bottom-0 end-0 m-2"
      >
        Editar
      </button>
    </div>
  );
};

export default ClientInfo;

